/**
 * Hlavní store aplikace.
 */
import { appbase, detail, utils, list } from "@mc/mc-legacy";
// Počáteční definice aplikačního store
const initialState = {
  ...appbase.baseReducer(),
  // APP BASE
  userRegistrationInfo: detail.DetailReducer(),
  userProfileDetail: detail.DetailReducer(),
  // jmeno uzivatele
  userProfileExternalDetail: detail.DetailReducer(),
  // ostatni udaje uzivatele z externi aplikace
  userProfileLoginList: list.SimpleListReducer(),
  // seznam zpusobu prihlaseni
  userProfileSubjektList: list.SimpleListReducer(),
  // seznam subjektu s pristupem (data z EOSP)
  userProfileSubjektExternalList: list.SimpleListReducer(), // seznam subjektu s pristupem (data z externi aplikace)
};
export default function app(state = undefined, action) {
  if (typeof state === "undefined") {
    state = { ...initialState };
  }

  if (action.area) {
    return utils.processAreaStores(state, action);
  }

  return state;
}
